import React from "react";
import HeaderOne from "../HeaderOne/Main";
import Breadcrumb from "../Breadcrumb/Main";
import Error from "../Menerror/Error";
import Newsletter from "../Menhomeone/Newsletter";
import FooterOne from "../FooterOne/Main";


function Main() {
  return (
    <div>
      <HeaderOne />
      <Breadcrumb title="Error Page" subtitle="Home" />
      <Error />
      <Newsletter />
      <FooterOne />
    </div>
  );
}

export default Main;
